export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5283.ba8e697e.jpg";